import { ReactNode, useCallback, useEffect, useMemo } from 'react';
import { useScrollIntoView } from '@mantine/hooks';
import StepContext, { StepContextType } from '@/context/StepContext/StepContext.tsx';
import { useActiveStep } from '@/layouts/AutomationPageWrapper/hooks/useActiveStep.ts';

// ------------------------
// Provider
// ------------------------

type StepProviderProps = {
  children: ReactNode;
};

export const StepProvider = ({ children }: StepProviderProps) => {
  const { stepId } = useActiveStep();

  const { scrollIntoView, targetRef, scrollableRef } = useScrollIntoView<HTMLDivElement>({
    offset: 50,
  });

  const scrollToActiveStep = useCallback(
    () => scrollIntoView({ alignment: 'start' }),
    [scrollIntoView],
  );

  useEffect(() => {
    if (stepId) scrollToActiveStep();
  }, [stepId, scrollIntoView, scrollableRef, targetRef, scrollToActiveStep]);

  const value = useMemo<StepContextType>(
    () => ({ scrollableRef, targetRef, scrollToActiveStep }),
    [scrollableRef, targetRef, scrollToActiveStep],
  );

  return <StepContext.Provider value={value}>{children}</StepContext.Provider>;
};
